import { axiosInstance } from "./config";


const API = "/orders";

export const getAllOrders = async () => {
  const res = await axiosInstance.get(API);
  return res.data;
};

export const createOrder = async (data) => {

  const res = await axiosInstance.post(API, data);
  return res.data;
};

export const updateOrder = async (id, data) => {
  try {
    const res = await axiosInstance.post(`${API}/${id}`, data);
    return res.data;
  } catch (err) {
    const res = await axiosInstance.put(`${API}/${id}`, data);
    return res.data;
  }
};

export const deleteOrder = async (id) => {
  const res = await axiosInstance.delete(`${API}/${id}`);
  return res.data;
};

export const startWorkOrder = async (id, data) => {
  const res = await axiosInstance.post(`${API}/${id}/start-work`, data);
  return res.data;
};

export const completeWorkOrder = async (id, data) => {
  const res = await axiosInstance.post(`${API}/${id}/complete-work`, data);
  return res.data;
};

export const getOrdersByEmployee = async (employee) => {
  const res = await axiosInstance.get(`${API}/employee/${encodeURIComponent(employee)}`);
  return res.data;
};
